import { Table as MantineTable } from '@mantine/core';
import { GoodTable } from './table';
import { GoodTableProvider } from './table-context';
import { GoodTableRoot } from './table-root';
import { GoodTableSlider } from './table-slider';
import { GoodTableTd } from './table-td';
import { GoodTableTh } from './table-th';
import { GoodTableThead } from './table-thead';
import { GoodTableTr } from './table-tr';
GoodTable.Caption = MantineTable.Caption;
GoodTable.DataRenderer = MantineTable.DataRenderer;
GoodTable.Provider = GoodTableProvider;
GoodTable.Root = GoodTableRoot;
GoodTable.ScrollContainer = MantineTable.ScrollContainer;
GoodTable.Slider = GoodTableSlider;
GoodTable.Tbody = MantineTable.Tbody;
GoodTable.Td = GoodTableTd;
GoodTable.Tfoot = MantineTable.Tfoot;
GoodTable.Th = GoodTableTh;
GoodTable.Thead = GoodTableThead;
GoodTable.Tr = GoodTableTr;
export * from './types';
export { GoodTable };
export { useGoodTableContext } from './table-context';
